import React from "react";
import FeatureGraphicPage from "./FeatureGraphicPage";

/**
 * 1080p featured-graphic recording — same art as `/feature-graphic`, fitted
 * to the browser window for OBS capture (contain, no crop).
 */
export default function FeatureGraphicRecording1080pPage() {
    return <FeatureGraphicPage fillCapture />;
}
